import { Component, ApplicationRef } from '@angular/core';
import { LoginDataService } from "app/login/login-data.service";
import { LoginComponent } from "app/login/login.component";
import { TranslateService } from "@ngx-translate/core";
import { Ng2DeviceService } from 'ng2-device-detector';
import { Router } from '@angular/router';

@Component({
	selector: 'vbn-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss']
})
export class AppComponent {
	deviceInfo = null;
	browserFailed: boolean = false;

	public options = {
		position: ["bottom", "right"],
		timeOut: 5000,
		lastOnBottom: true,
		maxStack: 3,
		preventDuplicates: true,
		showProgressBar: false
	}
	
	showLogin: any
	triggerLoginOutletMode: any
	constructor(public _login: LoginDataService, 
			private _route: Router,
			private translate: TranslateService, 
			private deviceService: Ng2DeviceService) {
		this.epicFunction();
		if (localStorage.getItem("vbn-language") === null) {
			this.translate.setDefaultLang('ro')
			this.translate.use('ro')
			localStorage.setItem("vbn-language", 'ro')
		} else if (localStorage.getItem("vbn-language") === 'en') {
			this.translate.setDefaultLang('en')
			this.translate.use('en')
			localStorage.setItem("vbn-language", 'en')
		} else if (localStorage.getItem("vbn-language") === 'fr') {
			this.translate.setDefaultLang('fr')
			this.translate.use('fr')
			localStorage.setItem("vbn-language", 'fr')
		}else if (localStorage.getItem("vbn-language") === 'ro') {
			this.translate.setDefaultLang('ro')
			this.translate.use('ro')
			localStorage.setItem("vbn-language", 'ro')
		} else if (localStorage.getItem("vbn-language") === 'de') {
			this.translate.setDefaultLang('de')
			this.translate.use('de')
			localStorage.setItem("vbn-language", 'de')
		}
		this.triggerLoginOutletMode = this._login.triggerLoginOutletMode.subscribe(
			message => {
				switch (message.action) {
					case 'logout':
						this.showLogin = LoginComponent
						break
					case 'hide':
						this.showLogin = null
						break
				}
			}
		)
	}

	epicFunction() {		
		this.deviceInfo = this.deviceService.getDeviceInfo();
		if(this.deviceInfo.browser === "ie" && this.deviceInfo.browser_version <= "12"){
			this._route.navigate(['/browserfail'])
		}
	}
}
